import PublicRequestPage from "./PublicRequestPage";
import { useLocal } from "hooks/useLocal";

const SupportRequestPage = () => {
  const { isArabic } = useLocal();

  const copy = isArabic
    ? {
        title: "طلب دعم",
        subtitle:
          "هل تحتاج إلى مساعدة؟ شارك بريدك الإلكتروني ورقم هاتفك وملاحظة قصيرة حتى يتمكن فريقنا من المتابعة بسرعة.",
        ctaLabel: "إرسال طلب الدعم",
        successTitle: "شكرًا لتواصلك معنا",
        successDescription:
          "سيقوم أحد أعضاء فريق Numuw بالتواصل معك لمساعدتك قريبًا.",
      }
    : {
        title: "Support request",
        subtitle:
          "Need help? Share your email, phone number, and a short note so our team can follow up quickly.",
        ctaLabel: "Send support request",
        successTitle: "Thanks for contacting us",
        successDescription:
          "Someone from the Numuw team will reach out to help you shortly.",
      };

  return (
    <PublicRequestPage
      endpoint="/api/landing/support-request/"
      title={copy.title}
      subtitle={copy.subtitle}
      ctaLabel={copy.ctaLabel}
      successTitle={copy.successTitle}
      successDescription={copy.successDescription}
      includeNote
    />
  );
};

export default SupportRequestPage;
